import { makeHttpRequest } from "@/shared";

export const deleteBreaking = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/broken/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
